module.exports = __webpack_public_path__ + "img/g-line-short.73e4e87a.svg";